<template>
    <div class="five">
      <!-- 1111 -->
        <div class="fiveBox" >
            <div class="fiveBoxTop">
                <p class="fiveBoxTopL animate__animated animate__zoomIn  animate__slow-1 animate__repeat-1" ref="fiveBoxTopL">{{title}}</p>
            </div>
            <div class="fiveBoxBottom">
                <div class="fiveBoxBottomL" >
                  <div class="fiveBoxBottomLItem"  @click="goInfo(goWay,ListLeftOne)">
                    <div class="fiveBoxBottomLItemImg">
                      <img v-lazy='ListLeftOne.TitlePic' :key="ListLeftOne.TitlePicc" class="fiveBoxBottomLImg">
                    </div>
                    <div class="fiveBoxBottomLItemBox">
                      <p class="fiveBoxBottomLIcon"></p>
                      <p class="fiveBoxBottomLTitle">{{ListLeftOne.Title}}</p>
                      <p class="fiveBoxBottomLText">{{ListLeftOne.Info}}</p>
                    <img class="fourIcon" src="../../index/pcHome/fourIcon.png" alt="">
                    </div>
                  </div>

                  <div class="fiveBoxBottomLItem fiveBoxBottomLItemFloat" @click="goInfo(goWay,ListLeftTwo)" >
                    <div class="fiveBoxBottomLItemImg">
                      <img v-lazy='ListLeftTwo.TitlePic' :key="ListLeftTwo.TitlePic" class="fiveBoxBottomLImg">
                    </div>

                    <div class="fiveBoxBottomLItemBox">
                      <p class="fiveBoxBottomLIcon"></p>
                      <p class="fiveBoxBottomLTitle" >{{ListLeftTwo.Title}}</p>
                      <p class="fiveBoxBottomLText">{{ListLeftTwo.Info}}</p>
                    <img class="fourIcon" src="../../index/pcHome/fourIcon.png" alt="">
                    </div>
                  </div>
                </div>
                <div class="fiveBoxBottomR"  ref="fiveBoxBottomRItem">
                    <p class="fiveBoxBottomRBtn" @click="goCase(goWay)">查看更多+</p>
                    <div  class="fiveBoxBottomRItem fiveBoxTopL animate__animated animate__slideInUp  animate__slow-1 animate__repeat-1" v-for="item in listRight" :key="item.ID" @click="goInfo(goWay,item)" >
                      <img v-lazy='item.TitlePic' class="fiveBoxBottomRImg" :key="item.TitlePic">
                    <div class="">
                      <p class="" >{{item.Title}}</p>
                    </div>
                    </div>
                </div>
                

                <!-- <p class="headNewsShow" >
                  <img src="~@/assets/img/noContent.png" alt="" >
                </p> -->
            </div>
        </div>
    </div>
</template>

<script>
export default {
  props:{
    title:{
      type:String,
      default:() =>('')
    },
    ListLeftOne:{
      type:Object,
      default:() =>({})
    },
    ListLeftTwo:{
      type:Object,
      default:() =>({})
    },
    listRight:{
      type:Array,
      default:() =>([])
    },
    goWay:{
      type:String,
      default:'newsItemNew'
    }
  },
 methods:{
    // goCaseInfo (item) {
    //   // this.$router.push(newsItem)
    //   this.$router.push({ path: `/caseShow/${item.ID}` })
    // },    
    goInfo (goWay,item) {
      // console.log(goWay,'ssss')
      // this.$router.push(newsItem)
      this.$router.push({ path: `/${goWay}/${item.ID}` })
    },
    goCase(goWay){
      if(goWay == 'newsItemNew'){
        this.$router.push('/newsCenter')
      }else{
        this.$router.push('/case')
      }
      
    }
 }
}
</script>

<style lang="scss" scoped>
$sun:100/192;
.five{
    width: 100%;
    height: 1000px*$sun;
    background: #fff;
    display: flex;
    align-items: center;
    // justify-content: center;
    overflow: hidden;
    .fiveBox{
        width: 1400px*$sun;
        height: 627px*$sun;
        margin: auto;
        margin-top: 0;
        .fiveBoxTop{
            display: flex;
            justify-content: space-between;
            width: 100%;
            height: 89px*$sun;
            .fiveBoxTopL{
              margin: 0;
              float: left;
                font-size: 36px*$sun;
                width: 710px*$sun;
                font-weight: 500;
            }
        }
        .fiveBoxBottom{
            width: 100%;
            height: 595px*$sun;
            display: flex;
            justify-content: space-between;
            .headNewsShow{
              width: 1400px*$sun;
              margin: auto;
                width: 480px*$sun;
                height: 480px*$sun;
              display: flex;
              justify-content: center;
              img{
                width: 480px*$sun;
                height: 480px*$sun;
              }
            }
            .fiveBoxBottomL:last-child{ 
                 float: right;
              }
            .fiveBoxBottomL{
                float: left;
                width: 815px*$sun;
                height: 600px*$sun;
                padding-right: 10px*$sun;
                cursor: pointer;
                overflow: hidden;
                .fiveBoxBottomLItem{
                  float: left;
                  width: 390px*$sun;
                  height: 595px*$sun;
                  background: #F6F9FE;
                  border-radius: 8px*$sun;
                  transition: all 0.2s;
                  overflow: hidden;
                  .fiveBoxBottomLItemImg{
                    width: 100%;
                    height: 270px*$sun;
                    margin-bottom: 27px*$sun;
                    overflow: hidden;
                  }
                  .fiveBoxBottomLItemBox{
                    padding: 0 23px*$sun;
                    overflow: hidden;
                    height: 280px*$sun;
                    .fourIcon{
                      float: right;
                      width: 38px*$sun;
                      height: 38px*$sun;
                    }
                  }
                }
                          // 动画
    .fiveBoxBottomLItem:hover p{
      color: #2380E1;
    }
    .fiveBoxBottomLItem:hover img{
      animation: move .5s linear forwards;
     }
     .fiveBoxBottomLItem:hover .fiveBoxBottomLImg{
      animation: move .5s linear forwards;
     }
    @keyframes move {
      0% {
        transform: scale(1);
      }
      100% {
        transform: scale(1.1);
      }
    }
     .fiveBoxBottomLItem:hover{
   /* 盒子向上移动 */
    transform: translateY(-2px*$sun);
    /* 背景 */
    box-shadow: 5px*$sun 5px*$sun 5px*$sun rgba(19, 19, 20, 0.15);
    // text-shadow: 5px*$sun 5px*$sun 5px*$sun #7676f3;
 }  
                .fiveBoxBottomLItemFloat{
                  float: right;
                }
                .fiveBoxBottomLImg{
                    width: 100%;
                    height: 270px*$sun;
                    // margin-bottom: 27px*$sun;
                 }
                .fiveBoxBottomLIcon{
                  margin: 0;
                  margin-bottom: 20px*$sun;
                  height: 20px*$sun;
                  width: 38px*$sun;
                  border-top: 6px*$sun solid #2380E1;
                  overflow: hidden;
                }
                 .fiveBoxBottomLTitle{
                    height: 54px*$sun;
                    font-size: 24px*$sun;
                    margin: 0;
                    margin-bottom: 20px*$sun;
                    font-weight: 500;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                 }
                 .fiveBoxBottomLText{
                    font-size: 16px*$sun;
                    font-weight: 500;
                    height: 100px*$sun;
                 }
            }
            // 右边
            .fiveBoxBottomR{
              float: right;
                width: 550px*$sun;
                cursor: pointer;
                position: relative;
                .fiveBoxBottomRBtn{
                  position: absolute;
                  right: 0;
                  bottom: 35px*$sun;
                  height: 43px*$sun;
                  width: 127px*$sun;
                  margin: 0;
                  font-size: 18px*$sun;
                  color: #9B9B9B;
                  font-weight: 500;
                  border:2px*$sun solid #9B9B9B;
                  line-height:43px*$sun;
                  text-align: center;
                }
                .fiveBoxBottomRBtn:hover{
                  color: #2380E1;
                }
                .fiveBoxBottomRItem{
                    width: 100%;
                    height: 120px*$sun;
                    border-bottom: 2px*$sun solid #EBEBEB;
                    margin-bottom: 21px*$sun;
                    p{
                      margin: 0;
                      float: right;
                      width: 380px*$sun;
                      font-size: 18px*$sun;
                      font-weight: 500;
                    }
                    .fiveBoxBottomRImg{
                      float: left;
                      width: 143px*$sun;
                      height: 94px*$sun;
                      margin-right: 20px*$sun;
                      img{
                        width: 100%;
                        height: 100%;
                      }
                    }
                }
                .fiveBoxBottomRItem:hover{
                  color:#2380E1;
                }
            }
            .fiveBoxBottomR :nth-last-child(1){
              border-bottom: 0px;
            }

        }
    }
}
</style>